export default __webpack_public_path__ + "static/media/Icon feather-globe.fce5aebb.svg";